import React from "react";
import { ProductAlertListBody } from "tsi-common-react/src/apps/customer-account/ProductAlertListBody/index";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.ProductAlertListDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <ProductAlertListBody {...props} />
    </PageSkeleton>
);
